import * as api from '@owl-nest/api-client/latest'
import * as hooks from '@owl-nest/hooks'
import * as models from '@owl-nest/models'
import * as services from '@owl-nest/services'
import * as UFE from '../UFE'

export type DisplayMode = 'preview' | 'edit' | 'view'

export function useDisplayMode(project: models.project.Project): DisplayMode {
  const auth = services.user.useAuth()
  const router = hooks.useNextRouter()

  const isUserStaff = auth.type === 'loggedin' ? auth.user.is_staff : Boolean(UFE.CURRENT_USER.is_staff)
  const editingUserRole = project ? models.project.getEditingUserRole(project, isUserStaff) : undefined
  const userPermissions = project.permissions.self

  const preview = isPreview(router.asPath)

  if (editingUserRole && !preview) {
    return 'edit'
  }
  const isProjectArchived = models.project.archived(project)

  if (isProjectArchived) {
    // No preview when project is archived
    return userPermissions?.includes(api.ProjectSelfPermission.UPDATE) ? 'edit' : 'view'
  } else {
    return userPermissions?.includes(api.ProjectSelfPermission.UPDATE) ? (preview ? 'preview' : 'edit') : 'view'
  }
}

export function isPreview(path: string): boolean {
  return path.includes('/preview/')
}
